"use client";

import React, { useState, useEffect, useCallback } from "react";
import { Table, Container, Spinner, Alert, Button, Form } from "react-bootstrap";
import CreateArticleModal from "./modal"; // Adjust the path as needed
import { toast } from "react-toastify";
import CustomPagination from "../../components/common/CustomPagination";
import { StatusChangeBlogsById, deleteBlogsById, getBlogs } from "../../api/blog";
import { PERPAGE_RECORD, showToast } from "../../utils/isValidImage";


const ArticleListTable = () => {
  const [articles, setArticles] = useState([]);
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchArticles = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);
    try {
      const { data } =  await getBlogs({page,limit:PERPAGE_RECORD})
      setArticles(data.data);
      setPagination(data.pagination);
    } catch (err) {
      console.error("Error fetching articles:", err);
      setError("Failed to fetch articles. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchArticles().then();
  }, [fetchArticles]);


  const handlePageChange = (page) => {
    fetchArticles(page).then();
  };

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  const handleArticleCreated = () => {
    fetchArticles().then();
  };

  const toggleStatus = async (plan) => {
    setLoading(true);
    try {
      // Adjust the endpoint as necessary if your POST endpoint differs.
      const { data } =  await StatusChangeBlogsById(plan?.id);
      //axios.patch(url);

      if(data){
        showToast("Article card status successfully!", true);
        handleArticleCreated()
      }
    } catch (err) {
      showToast(err.response?.data?.message || "An error occurred. Please try again.");
      // setError(err.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }

  }

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Article?")) {
      try {

        const { data:response } = await deleteBlogsById(id);
        if (response.message) {
          toast.success("Article deleted successfully!");
          await fetchArticles();
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        toast.error("Failed to delete Article.");
        console.error("Error deleting Article:", error);
      }
    }
  }

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger" style={{marginLeft:'160px'}}>
          {error}
          <div className="mt-3">
            <Button onClick={() => fetchArticles()}>Retry</Button>
          </div>
        </Alert>
      </Container>
    );
  }

  return (
    <div className="right-side-wrapper">
      <Container className="mt-4">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <h1 className="mb-4">Articles</h1>
          <Button variant="success" onClick={handleModalShow} className="mb-4">
            Upload New Article
          </Button>
        </div>
        <Table striped bordered hover responsive>
          <thead>
          <tr>
            <th>ID</th>
            <th>Image</th>
            <th>Title</th>
            <th>Status</th>
            <th>Uploaded At</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          {articles.map((article) => (
            <tr key={article.id}>
              <td>{article.id}</td>
              <td>
                <img
                  src={article.featured_image}
                  alt={article.title}
                  style={{ width: "100px", objectFit: "cover" }}
                />
              </td>
              <td>{article.title}</td>
              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px",  }}>
                    <span
                      className={`px-2  rounded-lg text-sm ${article.is_active ? "active-btn" : "inactive-btn"}`}
                      style={{ minWidth: "60px", textAlign: "center" }}
                    >
                        {article.is_active ? "Active" : "Inactive"}
                    </span>

                  <Form.Switch
                    id="custom-switch"
                    onChange={(e) => toggleStatus(article)}
                    checked={article.is_active}
                    className="mb-0"
                  />

                  {/* <Switch
                        onChange={() => toggleStatus(article)}
                        checked={article.is_active}
                        offColor="#ccc"
                        onColor="#4CAF50"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={20}
                        width={40}
                    /> */}
                </div>
              </td>
              <td>{new Date(article.created_at).toLocaleDateString()}</td>
              <td>
                <Button variant="primary" href={article.weblink} target="_blank" rel="noopener noreferrer">
                  Read Article
                </Button>
                <button
                  className="btn btn-outline-danger btn-sm m-2"
                  onClick={() => handleDelete(article.id)}
                >
                  Delete
                </button>
              </td>

            </tr>
          ))}
          </tbody>
        </Table>
        <CustomPagination pagination={pagination} handlePageChange={handlePageChange} />
      </Container>
      <CreateArticleModal
        show={showModal}
        handleClose={handleModalClose}
        onArticleCreated={handleArticleCreated}
      />
    </div>
  );
};

export default ArticleListTable;
